// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Daut","buttons":"styles_buttons__1_R4_"};